/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Unsubscribe_Invalid_DescriptionInputs */

const en_newsletter_unsubscribe_invalid_description = /** @type {(inputs: Newsletter_Unsubscribe_Invalid_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The unsubscribe link is invalid or has expired. Use the link from the latest email you received.`)
};

/**
* | output |
* | --- |
* | "The unsubscribe link is invalid or has expired. Use the link from the latest email you received." |
*
* @param {Newsletter_Unsubscribe_Invalid_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_unsubscribe_invalid_description = /** @type {((inputs?: Newsletter_Unsubscribe_Invalid_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Unsubscribe_Invalid_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_unsubscribe_invalid_description(inputs)
});